import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const HotelDetailSkeleton = () => {
  return (
    <div>
      <div style={{ position: "relative" }}>
        <Container>
          <div className="hotel-detailMain">
            <div className="hotel-detailSubMain">
              <div className="hotel-detailHeading">
                <div>
                  <div className="hotelListingstyling-name hotelListingstylingDetail-name">
                    <Skeleton width={300} />
                  </div>

                  <div className="hotel-Address">
                    <Skeleton width={500} />
                  </div>
                </div>
                <div className="hotel-numberic-rating hotelDetail-ratings">
                  <div>
                    <div className="rating-label">
                      <Skeleton width={100} />
                    </div>
                    <div className="rating-reviews">
                      <Skeleton width={150} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="hotelSilder_totalFare">
                <div className="hotel-ColbigSilder">
                  <div className="hotel-bigSilder">
                    <Skeleton height={250} width={800} />
                  </div>

                  <div className="carousel-belowImag">
                    <div>
                      <Skeleton height={170} width={250} />
                    </div>
                    <div>
                      <Skeleton height={170} width={250} />
                    </div>

                    <div className="carouselImage-container">
                      <Skeleton height={170} width={250} />
                    </div>
                  </div>
                </div>
                <div className="hotel-ColtotalFare">
                  <div className="hotel-totalFare">
                    <div style={{ display: "block" }}>
                      <div className="hoteRoom-Usage">
                        <Skeleton height={100} width={350} />
                      </div>

                      <div className="hotel-Guests_Room">
                        {" "}
                        <Skeleton width={200} />
                      </div>
                    </div>
                    <div className="hoteRoom-UsageCharges">
                      <div className="cross-pricing">
                        <Skeleton width={50} />
                      </div>
                      <div className="real-pricing">
                        <Skeleton width={50} />
                      </div>
                      <div className="hotel-taxesFees">
                        <Skeleton width={100} />
                      </div>
                      <div
                        className="hotel-taxesFees"
                        style={{ color: "#737373" }}
                      >
                        <Skeleton width={100} />
                      </div>
                    </div>
                  </div>

                  <div className="hotel-amenities" style={{ flexWrap: "wrap" }}>
                    <div className="free_amenities" style={{ border: "none" }}>
                      <Skeleton width={150} height={30} />
                    </div>
                    <div className="free_amenities" style={{ border: "none" }}>
                      {" "}
                      <Skeleton width={100} height={30} />
                    </div>
                    <div className="free_amenities" style={{ border: "none" }}>
                      <Skeleton width={150} height={30} />
                    </div>
                    <div className="free_amenities" style={{ border: "none" }}>
                      {" "}
                      <Skeleton width={150} height={30} />
                    </div>
                    <div className="free_amenities" style={{ border: "none" }}>
                      <Skeleton width={100} height={30} />
                    </div>
                    <div className="free_amenities" style={{ border: "none" }}>
                      <Skeleton width={150} height={30} />
                    </div>
                  </div>
                  {/* <button className="hotel-BookNowBtn">Book Now</button> */}
                </div>
              </div>
            </div>
          </div>
        </Container>
        <div className="hotel-RoomsOverViewMain">
          <Container>
            {/* <div className="hotel-RoomsOverViewMenu"> */}
             <Skeleton style={{width:'100%',border:'none'}} className="hotel-RoomsOverViewMenu" />
            

            <div className="hotel-RoomsOverViewMenuFinalBooking">
            <Skeleton style={{width:'100%',border:'none'}} className="hotel-RoomsOverViewRoomsBenefits" />
              {/* <div className="hotel-RoomsOverViewRoomsBenefits">
                <div>Room Type</div>
                <div>Benefits</div>
                <div>Per Night Price</div>
              </div> */}

              <div id="rooms-section">
                <Row className="hotel-finalRoomType-Row" >
                  <Col className="hotel-finalRoomType-Col">
                    <div className="hotel-finalRoomType"><Skeleton/></div>
                    <div>
                    <Skeleton height={200}/>
                    </div>
                    <div ><Skeleton width={80} height={30}/></div>
                  </Col>

                  <Col className="hotel-finalRoomType-Col">
                    <div className="hotel-RoomsOnly"><Skeleton/></div>
                    <div className="hotel-RoomsOverViewMain"><Skeleton/></div>
                  </Col>

                  <Col className="hotel-finalRoomType-Col">
                    <div className="hoteRoom-UsageCharges">
                      <div className="cross-pricing"><Skeleton width={100}/></div>
                      <div className="real-pricing"><Skeleton width={100}/></div>
                      <div className="hotel-taxesFees">
                      <Skeleton width={200}/>
                      </div>
                      <div
                        className="hotel-taxesFees"
                        style={{ color: "#737373" }}
                      >
                        <Skeleton width={200}/>
                      </div>
                    </div>
                   
                  </Col>

                  <Col className="hotel-finalRoomType-Col">
                    <div style={{textAlign:'end'}}>
                    <Skeleton width={100} height={50} style={{textAlign:'end'}}/> 
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

          
          </Container>
        </div>
      </div>
    </div>
  );
};

export default HotelDetailSkeleton;
